// @ts-nocheck
import React, {Component} from 'react';
import ReactMarkdown from 'react-markdown';
const openSource = require ('./open_source.md');
export default class OpenSource extends Component<any,any> {
  constructor(props: any) {
    super(props);
    this.state = {
      terms: "Loading..."
    };

  }
  componentDidMount(): void {
    fetch(openSource).then((response) => response.text()).then((text) => {
      this.setState({terms: text});
    });
  }
  render() {
    return (
      <div className="content">
        <ReactMarkdown source={this.state.terms} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/MainView/OpenSource.tsx